<template>
    <!--header area start-->
  <header class="header_area header_four">
    <!--header top start-->
    <div class="header_top">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="welcome_text">
              <p>
                {{ welcome_text }}
              </p>
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="top_right text-end">
              <ul>
                <li class="top_links" v-if="isAuthenticated">
                  <a href="/tai-khoan"><span>{{ account_link_text }}</span></a>
                </li>
                <li class="top_links" v-if="isAuthenticated">
                  <a @click="logout">Đăng xuất</a>
                </li>
                <li class="top_links" v-else>
                  <a @click="login">Đăng nhập</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--header top start-->

    <!--header middel start-->
    <div class="header_middle middle_four">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-3 col-md-3 col-12">
            <div class="logo">
              <router-link :to="{ name: 'home' }"><img src="/assets/img/logo/logo-web-dark.png" alt=""/></router-link>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-12">
            <div class="middel_right">
              <div class="search-container search_four">
                <div class="form">
                  <!-- <div class="hover_category">
                    <select class="select_option" name="select" id="categori">
                      <option>Tất cả danh mục</option>
                    </select>
                  </div> -->
                  <div class="search_box">
                    <!-- <input placeholder="Tìm tên hoặc mã sản phẩm" type="text" v-model="search_term" @change="findProduct"/> -->
                    <v-autocomplete
                      v-model="selectedProductId"
                      :items="search_items"
                      :search-input.sync="search_term"
                      :loading="loading_product"
                      hide-no-data
                      placeholder="Tìm tên hoặc mã sản phẩm"
                      item-text="filter_name"
                      item-value="id"
                      @change="onSelectSuggestion"
                    >
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-avatar>
                            <img :src="'/' + data.item.path">
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                            <v-list-item-subtitle v-html="data.item.product_code"></v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <button type="submit" @click="findProduct">Tìm kiếm</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
          </div>
        </div>
      </div>
    </div>
    <!--header middel end-->

    <!--header bottom satrt-->
    <div class="header_bottom sticky-header">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="main_menu_inner">
              <div class="main_menu menu_four">
                <nav>
                  <ul>
                    <li v-for="me in menus" :key="me.value"><router-link :to="{ name: me.value }"><span>{{ me.name }}</span></router-link></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--header bottom end-->
    <!--Offcanvas menu area start-->
    <div class="Offcanvas_menu canvas_defult">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="canvas_open">
              <span>MENU</span>
              <a href="javascript:void(0)"><i class="fa fa-bars"></i></a>
            </div>
            <div class="Offcanvas_menu_wrapper Offcanvas_four">
              <div class="canvas_close">
                <a href="javascript:void(0)"
                  ><i class="fa fa-close"></i
                ></a>
              </div>
              <!-- <div class="welcome_text">
                <p>
                  {{ welcome_text }}
                </p>
              </div> -->
              <!-- <div class="canvas_search_container">
                <div class="hover_category">
                  <select class="select_option" name="select" id="categori1" v-model="selectedCategory">
                    <option :value="null">Tất cả danh mục</option>
                  </select>
                </div>
                <div class="search_box">
                  <input placeholder="Từ khoá" type="text" v-model="search_term"/>
                  <button type="submit" @click="findProduct">Tìm kiếm</button>
                </div>
              </div> -->
              <div id="menu" class="text-start">
                <ul>
                    <li v-for="me in menus" :key="me.value"><router-link :to="{ name: me.value }"><span>{{ me.name }}</span></router-link></li>
                    <li><a href="/tai-khoan"><span>Quản lý tài khoản</span></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Offcanvas menu area end-->
  </header>
  <!--header area end-->
</template>
<script>
import { mapState } from "vuex";
import configs from "../configs";
export default {
  data() {
    return {
      welcome_text: "MikobiHouse - Cung cấp hàng sỉ/lẻ, thời trang chất lượng cao",
      menus: [
        {value: 'home', name: 'Trang chủ'},
        {value: 'gioi-thieu', name: 'Về chúng tôi'},
        {value: 'san-pham', name: 'Sản phẩm'},
        {value: 'chinh-sach-ctv', name: 'Chính sách CTV'},
        {value: 'hoi-dap', name: 'Hỏi đáp'},
      ],
      search_term: '',
      selectedCategory: null,
      selectedProductId: 0,
      loading_product: false,
      search_items: [],
    }
  },
  computed: {
    ...mapState({
      loading: state => state.categories.loading,
      auth_token: state => state.authentication.token,
      products: state => state.products.suggestions.data
    }),
    account_link_text() {
      return localStorage.getItem('jwt') !== null ? 'Tài khoản: ' + (this.$store.state.authentication.user.full_name || this.$store.state.authentication.user.phone.toString()) : 'Quản lý tài khoản';
    },
    isAuthenticated() {
      return this.auth_token;
    },
    params() {
      return this.$route.query;
    }
  },
  watch: {
    params() {
        this.search_term = this.params ? this.params.s : '';
    },
    products() {
      this.search_items.splice(0);
      if(this.products) {
        for (let i = 0; i < this.products.length; i++) {
          const element = this.products[i];
          this.search_items.push(element);
        }
      }
    },
    search_term (val) {
        // Items have already been requested
        if (!this.isAuthenticated || this.loading_product || !this.search_term) {
          this.$store.commit("products/setListSuggestion", {data: []})
          return;
        }
        this.$store.commit("products/setListSuggestion", {data: []})
        this.$store.dispatch("products/getListSuggestion", {filter: [{
            column: "filter_name",
            value: this.search_term,
            condition: "contain",
        }], pagination: {...configs.PAGINATION, itemsPerPage: 10}}).then(() => {this.loading_product = false;});
      },
  },
  methods: {
    logout() {
      this.$root.$emit("APP_LOGOUT");
    },
    login() {
      window.getApp.$router.replace('/dang-nhap');
    },
    findProduct() {
      if(this.search_term) {
        window.getApp.$router.push(`/san-pham?s=${this.search_term}`);
      }
      else {
        window.getApp.$router.push(`/san-pham`);
      }
    },
    onSelectSuggestion() {
      // window.location.replace(`/chi-tiet-san-pham/${this.selectedProductId}`);
      window.getApp.$router.push(`/chi-tiet-san-pham/${this.selectedProductId}`);
      this.selectedProductId = 0;
      this.search_term = '';
    }
  },
  mounted() {
        this.$root.$emit('COMPONENT_LOADED');
    }
}
</script>